import React, { useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import { useMutation, useQuery } from "react-query";
import {
  getRewards,
  getRewardsDashboard,
  getRewardsredemption,
  getRewardsStats,
  postResetLoyalty,
  updateRewards,
} from "../../../MyApi/rewards";
import { getCountriesUser } from "../../../MyApi/admin/countries/countries";
import StatsCard from "../../../Components/UI/staticsCard";
import {
  exchangeStatsConfig,
  orderAmountStatsConfig,
  rewardsStatsConfig,
  topPointsUsersColumns,
} from "../config";
import PenIcon from "../../../Components/Common/svg/penicon";
import WithdrawlModal from "../withdrawlmodal";
import DataTable from "../../../Components/UI/table/DataTable";
import FilterRewardsCard from "../../../Components/rewards/filter";
import Can from "../../../utils/can";
import Swal from "sweetalert2";

import { toast } from "react-toastify";
import TableActions from "../../../Components/UI/table/TableActions";
import StatusBadge from "../../../Components/UI/statusBadge";
import { formatPrice } from "../../../utils/formatPrice";

const PointsPage = () => {
  const [activeTab, setActiveTab] = useState("points");
  const [modalMode, setModalMode] = useState("add");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRewardId, setSelectedRewardId] = useState(null);

  // Filter state
  const [filterState, setFilterState] = useState({
    search: "",
    countryId: "",
  });

  // Countries query
  const { data: countriesData, isLoading: countriesLoading } = useQuery(
    ["countries"],
    () => getCountriesUser(localStorage.getItem("i18nextLng")),
  );

  const countries = countriesData?.data?.countries || [];
  const { data: statsData, isLoading: isLoadingStats } = useQuery(
    "getStatsRewards",
    getRewardsStats,
  );
  const {
    data: dashData,
    isLoading,
    refetch,
    isFetching,
  } = useQuery("getRewardsDashboard", () => getRewardsDashboard());
  const {
    data: rewardData,
    isLoading: isLoadingReward,
    error: rewardsError,
  } = useQuery(["getRewards", currentPage, filterState], () =>
    getRewards({
      search: filterState.search,
      countryId: filterState.countryId,
    }),
  );

  const {
    data: redemptionData,
    isLoading: redemptionLoading,
    error: redemptionError,
  } = useQuery(["getRewardsredemption", currentPage, filterState], () =>
    getRewardsredemption({
      search: filterState.search,
      countryId: filterState.countryId,
    }),
  );
  const statics = statsData?.data?.stats || [];

  const rewards = rewardData?.data?.rewards || [];
  const totalItems = rewardData?.data?.pagination?.total || 0;
  const last_page = rewardData?.data?.pagination?.last_page || 0;
  const totalredemptions = redemptionData?.data?.pagination?.total || 0;
  const lastPageRedemptions = redemptionData?.data?.pagination?.last_page || 0;

  const redemption = redemptionData?.data?.redemption || [];

  const deleteRewardMutation = useMutation({
    mutationKey: ["deleteReward"],
    mutationFn: (rewardId) => {
      const axios = require("axios");
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng");
      return axios.delete(`/v1/admin/rewards/${rewardId}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      });
    },
    onSuccess: (data) => {
      toast.success(`${data.data.message}`);
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  const resetLoyaltyMutation = useMutation({
    mutationKey: ["Reset"],
    mutationFn: (postData) => postResetLoyalty(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  const rewardsDashData =
    activeTab === "points"
      ? dashData?.data?.loyalty_reward || {}
      : activeTab === "orders_amout"
        ? dashData?.data.spending_reward || {}
        : {};

  console.log("rewardsDashData", rewardsDashData);
  const top_points_users = dashData?.data?.top_points_users || [];
  const top_spenders = dashData?.data?.top_spenders || [];

  const rewardsstatics = rewardsStatsConfig(statics);

  const orderRewardsStatics = orderAmountStatsConfig(statics);
  const exchangeRewardStatics = exchangeStatsConfig(statics);
  const openModal = (mode, rewardId = null) => {
    setIsModalOpen(true);
    setModalMode(mode);
    setSelectedRewardId(rewardId);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRewardId(null);
  };

  const onTabChange = (tab) => {
    setActiveTab(tab);
  };

  const systemRewardsColumns = [
    {
      label: "المكافأه",
      render: (row) => <div>{row.title}</div>,
    },
    { label: "الوصف", accessor: "description" },
    {
      label: "القيمة",
      render: (row) => (
        <div>
          {row.type === "wallet"
            ? formatPrice(row.country.currency_factor, row.value_amount)
            : row.coupon.code}{" "}
        </div>
      ),
    },
    { label: "النوع", accessor: "type" },
    { label: "عدد النقاط", render: (row) => <div>{row.points_cost} </div> },
    { label: "مرات الإستخدام", accessor: "usage_count" },
    { label: " المرات المستخدمة", accessor: "count_of_use" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row?.is_active ? "active" : "inActive"} />
      ),
    },
    { label: "تاريخ الانتهاء", accessor: "end_date" },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          editPermission="update_reward"
          deletePermission="delete_reward"
          edit={() => openModal("edit", row.id)}
          deleteFn={(rewardId) => deleteRewardMutation.mutate(rewardId)}
          id={row.id}
          mutationKey={["deleteReward"]}
        />
      ),
    },
  ];

  const handleReset = () => {
    resetLoyaltyMutation.mutate();
  };

  // Update rewards mutation
  const updateRewardsMutation = useMutation({
    mutationKey: ["updateRewards"],
    mutationFn: (postData) => updateRewards(postData, rewardsDashData.id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  // Handle end draw with confirmation
  const handleEndDraw = () => {
    Swal.fire({
      title: "تأكيد إنهاء السحب",
      text: "هل أنت متأكد من رغبتك في إنهاء السحب؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "نعم",
      cancelButtonText: "لا",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // Send update request with today's date as end date
        const today = new Date().toISOString().split("T")[0];
        updateRewardsMutation.mutate({
          end_date: today,
          _method: "PUT",
        });
      }
    });
  };

  // Filter handlers
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilterState((prev) => ({
      ...prev,
      search: value,
    }));
    setCurrentPage(1); // Reset to first page when filtering
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setFilterState((prev) => ({
      ...prev,
      countryId: value,
    }));
    setCurrentPage(1); // Reset to first page when filtering
  };

  return (
    <div>
      <HeaderBar
        title={"الأرباح"}
        content={"إدارة أرباح النظام، نقاط العملاء، وعمليات السحب والتبديل."}
      />
      {isModalOpen && (
        <WithdrawlModal
          isOpen={isModalOpen}
          modalId={selectedRewardId}
          toggle={closeModal}
          activeTab={activeTab}
          modalMode={modalMode}
          dashboardData={rewardsDashData}
        />
      )}
      <div className="row g-3 mt-3">
        {rewardsstatics?.map((stat, index) => (
          <div className="col-md" key={index}>
            <StatsCard {...stat} isLoading={isLoadingStats} />
          </div>
        ))}
      </div>{" "}
      <FilterRewardsCard
        searchTerm={filterState.search}
        countryId={filterState.countryId}
        onSearchChange={handleSearchChange}
        onCountryChange={handleCountryChange}
        countries={countries}
        countriesLoading={countriesLoading}
      />
      <div className="row">
        <div className="col-12">
          {activeTab !== "exchange" && (
            <div className="card rounded-4 shadow-sm">
              <div className="card-body">
                <div className=" d-flex justify-content-between">
                  <h5>تفاصيل السحب</h5>
                </div>

                <div className="row mt-3">
                  <div className="col-md-8 d-flex flex-column">
                    {Object.keys(rewardsDashData).length === 0 ? (
                      <>
                        <p className="desc text-start">
                          لا يوجد سحب متاح حاليًا
                        </p>
                        <p className="mb-3">
                          لم يتم إنشاء أي سحب في الوقت الحالي. يمكنك إنشاء سحب
                          جديد لتفعيل المشاركة وبدء احتساب النقاط.
                        </p>
                      </>
                    ) : (
                      <p>{rewardsDashData.title}</p>
                    )}

                    <p className="desc text-start mb-5">
                      {rewardsDashData.description}
                    </p>

                    {Object.keys(rewardsDashData).length === 0 ? (
                      <Can permission="create_reward">
                        <div>
                          {" "}
                          <button
                            className="btn btn-primary"
                            onClick={() => openModal("add")}
                          >
                            إنشاء سحب
                          </button>
                        </div>
                      </Can>
                    ) : (
                      <div className="d-flex align-items-center gap-2 mt-auto">
                        <Can permission="update_reward">
                          <button
                            className="btn btn-outline-primary  "
                            onClick={() => openModal("edit")}
                          >
                            <PenIcon />{" "}
                            <span className="ms-1"> تعديل السحب </span>
                          </button>
                        </Can>

                        <button
                          className="btn btn-primary"
                          onClick={handleEndDraw}
                        >
                          إنهاء السحب
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="col-md-4">
                    <div className="avatar">
                      <img className="img-fluid " src={rewardsDashData.image} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <DataTable
        columns={topPointsUsersColumns}
        data={top_points_users}
        title={"نقاط العملاء "}
        actionLabel={"مسح النقاط"}
        onAddClick={handleReset}
        createPermission={"delete_loyalty_setting"}
        emptyMessage="لا توجد بيانات  "
        isLoading={isLoading || resetLoyaltyMutation.isLoading}
        isFetching={isFetching}
      />
    </div>
  );
};

export default PointsPage;
